import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';
import tinycolor from 'tinycolor2';
import CheckIcon from '../icons/CheckIcon';
import LoadingIcon from '../icons/LoadingIcon';
import { getTextColorsFromColor } from '../lib/colors';
import Typography from '../Typography';

class Button extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    button: PropTypes.object,
    children: PropTypes.node,
    success: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    style: {},
    button: {},
    children: null,
    success: false,
    disabled: false,
    loading: false,
  };

  render() {
    const {
      event,
      site,
      section,
      classes,
      className,
      button,
      style,
      children,
      success,
      loading,
      disabled,
      ...other
    } = this.props;
    const { backgroundColor, ...filteredStyles } = style;

    return (
      <Typography
        component="button"
        className={classNames(
          classes.root,
          button.secondary ? classes.secondary : classes.primary,
          disabled && classes.disabled,
          className,
        )}
        style={filteredStyles}
        {...other}
      >
        <span className={success || loading ? classes.textHidden : undefined}>{children}</span>
        {loading && <LoadingIcon className={classNames(classes.icon, classes.iconLoading)} />}
        {success && <CheckIcon className={classes.icon} />}
      </Typography>
    );
  }
}

const defaultStyle = {
  backgroundColor: '#888',
};

function getStyle(props, name, mod) {
  const color = (props.style && props.style[name]) || defaultStyle[name];

  if (mod) {
    return tinycolor(color)[mod](5);
  }

  return color;
}

function getTextColor(props, mod) {
  const color = getTextColorsFromColor(props.site, props.style.backgroundColor).text.color;

  if (mod) {
    return tinycolor(color)[mod](5);
  }

  return color;
}

const stylesheet = theme => ({
  root: {
    display: 'inline-block',
    cursor: 'pointer',
    margin: theme.spacing.unit,
    minWidth: 120,
    padding: [[1.5 * theme.spacing.unit, 2 * theme.spacing.unit]],
    border: [[2, 'solid', 'transparent']],
    borderRadius: 0,
    textDecoration: 'none',
    textAlign: 'center',
    userSelect: 'none',
    position: 'relative',
    fontFamily: 'inherit',
    transition: theme.transitions.create(['color', 'background-color', 'border-color'], {
      duration: theme.transitions.duration.shortest,
    }),
    '& + &': {},
    [theme.breakpoints.down('sm')]: {
      maxWidth: 280,
      minWidth: 0,
    },
  },
  primary: {
    color: props => getTextColor(props),
    backgroundColor: props => getStyle(props, 'backgroundColor'),
    '&:hover': {
      color: props => getTextColor(props, 'lighten'),
      backgroundColor: props => getStyle(props, 'backgroundColor', 'lighten'),
    },
    '&:active': {
      color: props => getTextColor(props, 'darken'),
      backgroundColor: props => getStyle(props, 'backgroundColor', 'darken'),
    },
  },
  secondary: {
    color: props => getStyle(props, 'backgroundColor'),
    borderColor: props => getStyle(props, 'backgroundColor'),
    '&:hover': {
      color: props => getStyle(props, 'backgroundColor', 'lighten'),
      borderColor: props => getStyle(props, 'backgroundColor', 'lighten'),
    },
    '&:active': {
      color: props => getStyle(props, 'backgroundColor', 'darken'),
      borderColor: props => getStyle(props, 'backgroundColor', 'darken'),
    },
    backgroundColor: 'transparent',
  },
  disabled: {
    cursor: 'default',
    pointerEvents: 'none',
    outline: 'none',
    opacity: theme.opacity.disabled,
  },
  textHidden: {
    color: 'transparent',
  },
  icon: {
    position: 'absolute',
    height: 40,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    animation: {
      name: 'button-icon',
      duration: theme.transitions.duration.short,
      timingFunction: 'cubic-bezier(0.54, -0.01, 0.76, 3)',
    },
  },
  iconLoading: {
    width: 42,
  },
  '@keyframes button-icon': {
    '0%': {
      opacity: 0,
      transform: [['translate(-50%,-50%)', 'scale(0.8)']],
    },
    '100%': {
      opacity: 1,
      transform: [['translate(-50%,-50%)', 'scale(1)']],
    },
  },
});

export default injectSheet(stylesheet)(Button);



// WEBPACK FOOTER //
// ./src/site-render/src/Button/Button.js